var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-round w-100 cta-hero__cta ml-2 mr-2",attrs:{"disabled":_vm.toggleSaveBtn},on:{"click":_vm.handleSaveVideo}},[_vm._v("\n        "+_vm._s(_vm.toggleSaveBtn ? _vm.savedButtonText : _vm.buttonText)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c564b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/pages/components/aha-save-teaser-video.vue
// module id = 505
// module chunks = 0 1